import * as is from 'Services/Misc/is';
import { now } from 'Services/Misc/timing';

export const getCampaignIDFromIframe = (iframeTag = '') => {
  const campaignRegex = new RegExp('secure-gl\\.imrworldwide\\.com\\/u\\/t\\/00\\/([0-9\\/]+)\\/'),
        campaignID = campaignRegex.exec(iframeTag);

  if(campaignID && campaignID.length) {
    let id = campaignID[1].replace(/\//g, '');

    if(id && is.num(Number(id))) {
      return Number(id);
    }
  }
};

export const campaignIDToRoute = (campaignID = '') => {
  if(is.num(campaignID)) {
    campaignID = campaignID.toString();
  }

  while(campaignID.length && campaignID.length < 6) {
    campaignID = '0' + campaignID;
  }

  if(campaignID.length === 0) {
    return '';
  }

  return campaignID.split('').reduce( (routed, digit, index) => {
    routed += digit;
    if((index + 1) % 2 === 0) {
      routed += '/';
    }
    return routed;
  }, '');
};

export const controlSurveyPending      = (configuration, measurement) => is.def(configuration.UI.survey) ? measurement.survey_complete === 0 : false;
export const exposedSurveyPending      = (configuration, measurement) => is.def(configuration.UI.survey) ? measurement.survey_complete < 2 : false;
export const getNielsenImpressionPixel = (adContext = {}, campaignID = '') => `https://secure-gl.imrworldwide.com/u/ad?ca=${campaignID}&am=3&ce=Acuity&cr=${adContext.Creative}&pc=${adContext.Placement}&r=${now()}`;
export const getNielsenVideoTag        = (adContext = {}, campaignID = '') => {
  if(is.num(campaignID)) {
    campaignID = campaignID.toString();
  }

  if(campaignID.indexOf('/') === -1) {
    campaignID = campaignIDToRoute(campaignID);
  }

  return `https://secure-gl.imrworldwide.com/u/t/00/${campaignID}video_tag.html?cr=${adContext.Creative}&ce=Acuity&am=3&view=&r=${now()}`;
};


// WEBPACK FOOTER //
// ./src/Services/Misc/survey.js